import React, { useEffect, useState } from 'react'
import { Task } from '../../list/types'
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CButton,
  CFormTextarea,
} from '@coreui/react-pro'
import { Flex, Image, notification } from 'antd'
import { $error, moderationTask, moderationTaskSubmit } from './model'
import { NotificationPlacement } from 'antd/es/notification/interface'
import { useUnit } from 'effector-react'
import { tasksListMounted } from '../../list/model'

type Props = {
  isVisible: boolean
  onClose: () => void
  data: Task | null
  doneData: number
  setDoneData: (i: number) => void
}

export const ClientTaskModal: React.FC<Props> = ({
  isVisible,
  onClose,
  data,
  doneData,
  setDoneData,
}) => {
  if (!data) return null
  const [isDeclineReason, setIsDeclineReason] = useState<boolean>(false)
  const [declineReason, setDeclineReason] = useState('')

  const [api, contextHolder] = notification.useNotification()

  const saveError = useUnit($error)

  moderationTask.doneData.watch((result) => {
    if (result) {
      setDoneData(doneData + 1)
      onClose()
    }
  })

  const openNotification = (placement: NotificationPlacement) => {
    api.error({
      message: `Error`,
      description: `${saveError.message}`,
      placement,
    })
  }

  useEffect(() => {
    if (saveError.code !== 0) {
      openNotification('topRight')
    }
  }, [saveError])

  return (
    <CModal visible={isVisible} onClose={onClose}>
      {contextHolder}
      <CModalHeader>
        <CModalTitle>Task</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <Flex vertical justify="space-between" align="center">
          {data.checkType === 'image' ? (
            <Image
              className="mb-3"
              width={250}
              src={data.imgUrl}
              preview={false}
            />
          ) : (
            <a className="mb-3" href={data.checkValue} target="_blank">
              {data.checkValue}
            </a>
          )}
          {isDeclineReason && (
            <div className="mb-3 w-100">
              <CFormTextarea
                label="Decline reason"
                value={declineReason}
                onChange={(e) => setDeclineReason(e.target.value)}
              />
            </div>
          )}
          <div className="d-flex gap-3">
            <CButton
              color="success"
              onClick={() => {
                setIsDeclineReason(false)
                setDeclineReason('')
                moderationTaskSubmit({ id: data.id, status: 'accepted' })
              }}
            >
              Approve
            </CButton>
            <CButton
              color="danger"
              onClick={() => {
                if (!isDeclineReason) {
                  setIsDeclineReason(true)
                } else {
                  moderationTaskSubmit({
                    id: data.id,
                    status: 'declined',
                    declineReason: declineReason,
                  })
                }
              }}
            >
              Reject
            </CButton>
          </div>
        </Flex>
      </CModalBody>
    </CModal>
  )
}
